export function formatDateTime(time, format) {
	var t = new Date(time);
	var tf = function(i) {
		return (i < 10 ? "0" : "") + i;
	};
	return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function(a) {
		switch (a) {
			case "yyyy":
				return tf(t.getFullYear());
				break;
			case "MM":
				return tf(t.getMonth() + 1);
				break;
			case "mm":
				return tf(t.getMinutes());
				break;
			case "dd":
				return tf(t.getDate());
				break;
			case "HH":
				return tf(t.getHours());
				break;
			case "ss":
				return tf(t.getSeconds());
				break;
		}
	});
}


export function changeParams(data) {
	if (typeof data !== 'object') {
		return false
	}
	for (var key in data) {
		let item = data[key]
		if (item === '' || item === undefined) {
			delete data[key]
		}
	}
	return data
}


export function triggerEvent(el, eventName) {
	var event;
	if (document.createEvent) {
		event = document.createEvent('MouseEvent');
		event.initEvent(eventName, true, true);
	} else if (document.createEventObject) { // IE < 9
		event = document.createEventObject();
		event.eventType = eventName;
	}
	if (el.dispatchEvent) {
		el.dispatchEvent(event);
	} else if (el.fireEvent && htmlEvents['on' + eventName]) { // IE < 9
		el.fireEvent('on' + event.eventType, event); // can trigger only real event (e.g. 'click')
	} else if (el[eventName]) {
		el[eventName]();
	} else if (el['on' + eventName]) {
		el['on' + eventName]();
	}
}

export function debounce(fn, timeout) {
  let timer;
  return function() {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      fn.call(this, ...arguments)
    }, timeout)
  }
}



export function checkBtnAuth(menuList, menuCode, btnCode) {
    if (menuList && menuList.length > 0) {
        for (let i = 0; i < menuList.length; i++) {
            for (let j = 0; j < menuList[i].children.length; j++) {
                if (menuList[i].children[j].code === menuCode) {
                    for (let k = 0; k < menuList[i].children[j].children.length; k++) {
                        if (menuList[i].children[j].children[k].code === btnCode) {
                            return true;
                        }
                    }
                }
            }
        }
    }
    return false
}

export function checkPapers (parama, paramb) {
    var map = new Map([
        ['phone', /^[1][3,4,5,6,7,8,9][0-9]{9}$/],
        ['passport', !/^((1[45]\d{7})|(G\d{8})|(P\d{7})|(S\d{7,8}))?$/],
        ['identity', /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/],
        ['money', /^[0-9]+(\.[0-9]{1,2})?$/],
        ['moneyorMinus', /^(\-|\+)?\d+(\.\d{1,2})?$/],
        ['integer', /^[0-9]\d*$/],
        ['email',/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/],
        ['num_0_1',/^(0+(\.[0-9]{1,2})?|1|1.0|1.00?)$/]
    ])
    if (map.get(parama).test(paramb)) {
        return true
    } else {
        return false
    }
}

export function toFixed(num, size) {
	return Math.round(num *  Math.pow(10,size)) / Math.pow(10,size)
}

export function downloadFile(blob, fileName) {
  if ("download" in document.createElement("a")) {
    const elink = document.createElement("a");
    elink.download = fileName;
    elink.style.display = "none";
    elink.href = URL.createObjectURL(blob);
    document.body.appendChild(elink);
    elink.click();
    URL.revokeObjectURL(elink.href);
    document.body.removeChild(elink);
  } else {
    navigator.msSaveBlob(blob, fileName);
  }
}

export function downloadUrlFile(url) {
  if (!url) {
    return;
  }
  const protocol = window.location.protocol;
  if (protocol === 'https:') {
    url = url.replace('http://', 'https://');
  }
  window.open(url);
}

export function downloadMoreFile(url, fileName) {
  const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  iframe.style.height = "0";
  iframe.src = url;
  document.body.appendChild(iframe);
  // 不能马上将 iframe 删除，否则也会出现取消的情况
  setTimeout(() => {
    iframe.remove();
  }, 3000);
}
